export const mapCountryCodeToCurrencyCode = (countryCode) => {
    switch (countryCode.toLowerCase()) {
        // Euro countries
        case 'at':
        case 'ax':
        case 'be':
        case 'cy':
        case 'de':
        case 'es':
        case 'fi':
        case 'fr':
        case 'gr':
        case 'ie':
        case 'it':
        case 'lt':
        case 'lu':
        case 'lv':
        case 'mt':
        case 'nl':
        case 'pt':
        case 'si':
        case 'sk':
            return 'EUR';

        // Other selected countries
        case 'dk':
            return 'DKK';
        case 'gb':
            return 'GBP';
        case 'jp':
            return 'JPY';
        case 'no':
            return 'NOK';
        case 'se':
            return 'SEK';
        case 'us':
            return 'USD';

        // Default currency is SEK
        default:
            return 'SEK';
    }
};
